var _rect, _path, _path2, _path3, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoal12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "#bf8b2e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.428,89.386h.035v17.287h3.8V84.09H79.226l-3.5,4.1v3.963h.032Z",
    transform: "translate(-67.248 -74.669)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.716,86.65V89.38h3.463V86.548c0-1.364.672-1.764,1.466-1.764.734,0,1.365.3,1.365,1.7v1.864c0,1.867-.166,2.6-1.4,3.9l-2.128,2.266c-2.064,2.2-2.832,3.664-2.832,5.9v4.164h9.856v-3.1h-6.227v-1.065a4.31,4.31,0,0,1,1.6-3.464l2.428-2.565c1.966-2.1,2.4-3.432,2.4-5.7v-2.2c0-3.232-1.568-4.763-4.964-4.763-3.331,0-5.029,1.765-5.029,4.928",
    transform: "translate(-136.441 -72.564)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.817,504a20.234,20.234,0,0,0-12.187-4,13.384,13.384,0,0,0-2.942.283l-.3.069c-2.893.683-7.735,1.827-13.372,8.822l-.166.2a.732.732,0,0,0-.141.423.75.75,0,0,0,.1.371l.128.209q1.4,2.335,2.318,4.055a.745.745,0,0,0,1.205.169c.039-.052.079-.106.112-.148,4.863-6.732,8.678-7.628,11.2-8.225l.317-.075a7.387,7.387,0,0,1,1.546-.131,14.324,14.324,0,0,1,8.437,2.708c2.832,2.24,4.268,5.806,4.268,10.612,0,8.055-3.9,11.2-7.168,12.414a11.38,11.38,0,0,1-4,.7,14.184,14.184,0,0,1-6-1.365l-.234-.112c-2.812-1.221-7.011-3.767-10.982-11.739-8.138-16.352-14.974-17.9-19.5-18.92l-.237-.053a13.541,13.541,0,0,0-2.912-.262,19.419,19.419,0,0,0-11.984,3.965c-2.95,2.352-6.469,6.925-6.469,15.344,0,5.126,1.056,8.512,3.763,12.073a18.016,18.016,0,0,0,14.28,6.785,22.049,22.049,0,0,0,4.135-.405,17.641,17.641,0,0,0,7.056-3.223l2.38,2.148a.712.712,0,0,0,.967-.045.627.627,0,0,0,.171-.448l1.841-11.343v-.132a.672.672,0,0,0-.224-.5.663.663,0,0,0-.477-.176h0L185.7,527.1l-.211.035a.642.642,0,0,0-.351.2.683.683,0,0,0,.047.971l2.288,2.07a10.783,10.783,0,0,1-3.575,1.456,15.658,15.658,0,0,1-2.93.287,11.951,11.951,0,0,1-9.463-4.281l-.062-.085c-1.9-2.5-2.547-4.63-2.547-8.438,0-4.823,1.411-8.4,4.194-10.618a13.878,13.878,0,0,1,8.231-2.663,7.772,7.772,0,0,1,1.568.131l.244.055c3.613.819,8.561,1.939,15.422,15.719,3.623,7.28,8.167,12.033,13.878,14.542a20.48,20.48,0,0,0,8.747,2.028,17.423,17.423,0,0,0,6.1-1.083c3.335-1.244,11.1-5.5,11.1-18.079C238.383,510.945,234.812,506.362,231.817,504Z",
    transform: "translate(-144.62 -443.997)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.739 9.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.639,88.606v4.2H319.1V83.65h2.24c1.557,0,2.117.769,2.117,2.055V86.88c0,.986-.352,1.568-1.232,1.768l1.472,4.159h-1.613Zm0-3.7v2.845h.513a.667.667,0,0,0,.757-.756V85.655c0-.5-.23-.743-.757-.743Z",
    transform: "translate(-319.1 -83.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.39,83.65h3.672v1.257h-2.128v2.619h1.525v1.243h-1.53v2.781h2.128V92.8H365.39Z",
    transform: "translate(-360.206 -83.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.69,89.946V88.714h1.431v1.256c0,.513.224.811.756.811.486,0,.7-.325.7-.811v-.347a1.656,1.656,0,0,0-.689-1.3l-.9-.9a3.088,3.088,0,0,1-1.284-2.445v-.31a1.912,1.912,0,0,1,2.16-2.016c1.54,0,2.147.756,2.147,2.079v.744h-1.4v-.8c0-.526-.243-.784-.729-.784a.676.676,0,0,0-.729.756v.189c0,.513.283.81.729,1.242l.983.979a3.076,3.076,0,0,1,1.243,2.377v.448a1.981,1.981,0,0,1-2.24,2.147A1.908,1.908,0,0,1,404.69,89.946Z",
    transform: "translate(-395.104 -82.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,83.65h2.281c1.552,0,2.12.769,2.12,2.053v1.931c0,1.282-.568,2.065-2.12,2.065h-.743V92.8H451Zm1.539,1.257v3.6h.567a.661.661,0,0,0,.756-.756V85.649c0-.5-.23-.743-.756-.743Z",
    transform: "translate(-436.227 -83.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.28,89.589V85.161a2.333,2.333,0,1,1,4.658,0v4.428a2.333,2.333,0,1,1-4.658,0Zm3.119.243V84.918c0-.553-.243-.945-.8-.945s-.784.392-.784.945v4.915c0,.554.243.945.784.945s.8-.391.8-.945Z",
    transform: "translate(-477.324 -82.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.886,87.049V92.8h-1.3V83.65H548.1l1.661,5.253V83.65h1.282V92.8h-1.351Z",
    transform: "translate(-521.111 -83.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.48,89.946V88.714h1.431v1.256c0,.513.224.811.756.811.486,0,.7-.325.7-.811v-.347a1.656,1.656,0,0,0-.689-1.3l-.9-.9a3.09,3.09,0,0,1-1.282-2.445v-.31a1.912,1.912,0,0,1,2.16-2.016c1.539,0,2.147.756,2.147,2.079v.744h-1.4v-.8c0-.526-.243-.784-.729-.784a.675.675,0,0,0-.729.756v.189c0,.513.283.81.729,1.242l.986.972a3.074,3.074,0,0,1,1.242,2.377v.448a1.981,1.981,0,0,1-2.24,2.147A1.9,1.9,0,0,1,593.48,89.946Z",
    transform: "translate(-562.749 -82.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.77,83.65h1.54V92.8h-1.54Z",
    transform: "translate(-603.855 -83.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.35,83.65h2.229c1.539,0,2.052.716,2.052,2.016V86.6a1.329,1.329,0,0,1-.918,1.456,1.388,1.388,0,0,1,1.148,1.525v1.215c0,1.3-.58,2.016-2.12,2.016h-2.39Zm1.54,3.862h.54a.649.649,0,0,0,.729-.743v-1.12a.646.646,0,0,0-.743-.743h-.526Zm0,1.175v2.863h.672a.663.663,0,0,0,.757-.743V89.429c0-.486-.224-.743-.771-.743Z",
    transform: "translate(-623.018 -83.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.37,83.65h1.539v7.9h1.837V92.8H708.37Z",
    transform: "translate(-664.772 -83.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.66,83.65h3.673v1.257H746.2v2.619h1.523v1.243H746.2v2.781h2.134V92.8H744.66Z",
    transform: "translate(-696.997 -83.538)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.739 22.702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.1,209.609v-4.428c0-1.431.672-2.471,2.295-2.471,1.7,0,2.174.945,2.174,2.295v1.081h-1.4v-1.2c0-.568-.189-.9-.744-.9s-.784.392-.784.945v4.915c0,.553.23.945.784.945s.744-.351.744-.9v-1.679h1.4v1.58c0,1.309-.54,2.281-2.174,2.281S319.1,211.03,319.1,209.609Z",
    transform: "translate(-319.1 -202.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.68,209.609v-4.428a2.334,2.334,0,1,1,4.659,0v4.428a2.334,2.334,0,1,1-4.659,0Zm3.119.243v-4.915c0-.553-.243-.945-.8-.945s-.784.392-.784.945v4.915c0,.553.243.945.784.945S370.8,210.406,370.8,209.852Z",
    transform: "translate(-362.239 -202.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.607,207.073v5.752h-1.3V203.67h1.513l1.661,5.253V203.67h1.282v9.155h-1.355Z",
    transform: "translate(-407.198 -203.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.42,209.966v-1.232h1.431v1.256c0,.513.224.81.756.81.486,0,.7-.324.7-.81v-.352a1.654,1.654,0,0,0-.689-1.3l-.9-.9A3.083,3.083,0,0,1,466.434,205v-.31a1.912,1.912,0,0,1,2.16-2.016c1.539,0,2.147.756,2.147,2.079v.743h-1.406v-.8c0-.526-.243-.784-.729-.784a.675.675,0,0,0-.729.756v.189c0,.513.283.81.729,1.242l.986.972a3.074,3.074,0,0,1,1.242,2.377v.448a1.98,1.98,0,0,1-2.24,2.146A1.9,1.9,0,0,1,466.42,209.966Z",
    transform: "translate(-449.92 -202.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.749,203.67V210.6c0,1.418-.607,2.335-2.174,2.335a2.064,2.064,0,0,1-2.295-2.335V203.67h1.537v7.075c0,.541.216.9.756.9s.756-.364.756-.9V203.67Z",
    transform: "translate(-492.42 -203.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.46,206.883h-.04l-1.04,5.942h-.72l-1.142-5.942h-.028v5.942H563.22V203.67h1.792l1,5.158h.013l.9-5.158h1.945v9.155H567.46Z",
    transform: "translate(-535.878 -203.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.66,203.67h2.278c1.552,0,2.12.769,2.12,2.053v1.931c0,1.282-.568,2.065-2.12,2.065H624.2v3.106H622.66Zm1.539,1.256v3.605h.567a.661.661,0,0,0,.756-.756v-2.107c0-.5-.224-.743-.756-.743Z",
    transform: "translate(-588.661 -203.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.42,203.67h4.1v1.256h-1.276v7.9h-1.552v-7.9H666.42Z",
    transform: "translate(-627.52 -203.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.46,203.67H711v9.155H709.46Z",
    transform: "translate(-665.74 -203.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.15,209.609v-4.428a2.334,2.334,0,1,1,4.659,0v4.428a2.334,2.334,0,1,1-4.659,0Zm3.119.243v-4.915c0-.553-.243-.945-.8-.945s-.784.392-.784.945v4.915c0,.553.243.945.784.945S734.269,210.406,734.269,209.852Z",
    transform: "translate(-685 -202.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782,207.073v5.752h-1.3V203.67h1.512l1.658,5.253V203.67h1.284v9.155h-1.347Z",
    transform: "translate(-729.001 -203.558)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.496 36.149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.93,332.855l1.728-9.155h1.752l1.743,9.155h-1.577l-.278-1.674h-1.64l-.264,1.674Zm1.931-2.9h1.232l-.608-3.674h-.013Z",
    transform: "translate(-316.93 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.906,327.1v5.752h-1.3V323.7h1.512l1.661,5.252V323.7h1.284v9.155h-1.351Z",
    transform: "translate(-363.71 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.194,326.157V330.4c0,1.4-.58,2.458-2.228,2.458H417.59V323.7h2.377C421.614,323.7,422.194,324.742,422.194,326.157Zm-2.417,5.441c.635,0,.878-.377.878-.932v-4.792a.8.8,0,0,0-.878-.918h-.648V331.6Z",
    transform: "translate(-406.316 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.92,323.7H482.2c1.553,0,2.12.769,2.12,2.052v1.931c0,1.282-.567,2.066-2.12,2.066h-.743v3.106H479.92Zm1.539,1.256v3.605h.567a.662.662,0,0,0,.757-.756V325.7c0-.5-.23-.743-.757-.743Z",
    transform: "translate(-461.665 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.23,328.655v4.2h-1.54V323.7h2.24c1.552,0,2.119.769,2.119,2.052v1.175c0,.986-.351,1.568-1.232,1.768l1.472,4.16h-1.614Zm0-3.7v2.849h.511a.667.667,0,0,0,.756-.757v-1.344c0-.5-.224-.743-.756-.743Z",
    transform: "translate(-503.197 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.47,329.63V325.2a2.333,2.333,0,1,1,4.658,0v4.43a2.333,2.333,0,1,1-4.658,0Zm3.119.243v-4.916c0-.553-.243-.945-.8-.945s-.784.392-.784.945v4.916c0,.553.243.945.784.945S576.589,330.427,576.589,329.873Z",
    transform: "translate(-544.737 -322.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.864,326.157V330.4c0,1.4-.581,2.458-2.228,2.458H623.26V323.7h2.377C627.283,323.7,627.864,324.742,627.864,326.157Zm-2.417,5.441c.635,0,.877-.377.877-.932v-4.792a.8.8,0,0,0-.877-.918H624.8V331.6Z",
    transform: "translate(-588.951 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.03,323.7v6.926c0,1.418-.608,2.336-2.174,2.336a2.066,2.066,0,0,1-2.3-2.336V323.7h1.54v7.075c0,.54.216.9.756.9s.756-.365.756-.9V323.7Z",
    transform: "translate(-632.73 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.67,329.63V325.2c0-1.431.672-2.471,2.295-2.471,1.7,0,2.174.945,2.174,2.3v1.08h-1.408v-1.2c0-.567-.188-.9-.743-.9s-.784.392-.784.945v4.916c0,.553.23.945.784.945s.743-.352.743-.9v-1.679h1.4v1.577c0,1.309-.54,2.281-2.174,2.281S720.67,331.048,720.67,329.63Z",
    transform: "translate(-675.451 -322.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.84,323.7h4.091v1.256h-1.273v7.9h-1.549v-7.9H766.84Z",
    transform: "translate(-716.45 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.88,323.7h1.539v9.155H809.88Z",
    transform: "translate(-754.67 -323.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.58,329.63V325.2a2.333,2.333,0,1,1,4.658,0v4.43a2.333,2.333,0,1,1-4.658,0Zm3.118.243v-4.916c0-.553-.243-.945-.8-.945s-.784.392-.784.945v4.916c0,.553.243.945.784.945S834.7,330.427,834.7,329.873Z",
    transform: "translate(-773.939 -322.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.417,327.1v5.752h-1.3V323.7h1.513l1.661,5.252V323.7h1.282v9.155h-1.351Z",
    transform: "translate(-817.931 -323.591)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal12);
export default __webpack_public_path__ + "static/media/goal-12.897628157ae61e2e8cef48253a802f33.svg";
export { ForwardRef as ReactComponent };